import { useCallback, useEffect, useState } from 'react';

export const MODAL_DATA_ATTRIBUTE_NAME = 'data-dialog-modal';
export const DRAWER_DATA_ATTRIBUTE_NAME = 'data-dialog-drawer';

export function findPinchableDialogs() {
  return document.querySelectorAll(`[${DRAWER_DATA_ATTRIBUTE_NAME}][data-state="open"], [${MODAL_DATA_ATTRIBUTE_NAME}][data-state="open"]`);
}

export function useMergedDialogOpenProps({
  isOpen,
  onOpenChange,
}: {
  isOpen?: boolean;
  onOpenChange?: (newOpen: boolean) => void;
}): [boolean, (newOpen: boolean) => void] {
  const [isOpenState, setIsOpenState] = useState(Boolean(isOpen));
  const isOpenValue = isOpenState;
  const onOpenChangeValue = useCallback(
    (newOpen: boolean) => {
      setIsOpenState(newOpen);
      onOpenChange?.(newOpen);
    },
    [onOpenChange],
  );

  useEffect(() => {
    if (isOpen !== undefined) {
      setIsOpenState(isOpen);
    }
  }, [isOpen]);

  return [isOpenValue, onOpenChangeValue];
}
